import { RestaurantItem } from '@restaurant/types';
import httpClient from '~/http';

export const fetchRestaurants = () => {
  return httpClient.get<{ restaurants: RestaurantItem[] }>(
    '/api/v2/users/me/restaurants'
  );
};
